// File type detection and helper utilities for FileReader component

import { dibels_columns } from "../../../utils/files";

export const CSV_FILE_TYPES = [
  "text/comma-separated-values",
  "text/csv",
  "application/csv",
  "application/vnd.ms-excel",
  "application/vnd.msexcel",
  "csv",
];

export const EXCEL_FILE_TYPES = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "xlsx",
  "application/wps-office.xlsx"
];

export const STUDENT_ID_COLUMNS: string[] = [
  'ID',
  'Student ID',
  'Student ID#',
  'student_id',
  'StudentId',
  'Student_ID',
  'first_name',
  'last_name',
  'First',
  'Last'
];

export const LINKIT_CONSTANTS = ["Export Date", "Selected Tests"];
export const LINKIT_COLUMN_MUST_HAVE = ["student", "id", '"id"'];
export const DOUBLE_HEADER_COLUMN_HAVE = [
        dibels_columns.LNF,
        dibels_columns.PSF,
        dibels_columns["NWF-CLS"],
        dibels_columns["NWF-WRC"],
        dibels_columns.WRF,
        dibels_columns["ORF-WordsCorrect"],
        dibels_columns["ORF-Accuracy"],
        dibels_columns["Maze-Adjusted"],
        dibels_columns.Composite
      ];

export enum FileType {
  LINKIT = 'LINKIT',
  DESSA = 'DESSA',
  DDMS = 'DDMS',
  MCLASS = 'MCLASS',
  NJTSS = 'NJTSS',
  ISTEEP = 'ISTEEP',
  GENERIC = 'GENERIC'
}

/**
 * Detect the file type based on CSV data content
 */
export function detectFileType(csvData: string, columnsNames?: string[]): FileType {
  const csvDataArray = csvData.split('\n');
  const firstRow = csvDataArray[0] || '';
  const secondRow = csvDataArray[1] || '';

  // Check for iSteep file
  if (csvData.toLowerCase().includes('Test Date'.toLowerCase())) {
    return FileType.ISTEEP;
  }

  // Check for DDMS file
  if (firstRow.includes('District_Name')) {
    return FileType.DDMS;
  }

  // Check for mClass file
  if (firstRow !== '' && (firstRow.includes('StudentSummary') || firstRow.includes('Student Summary')) && !firstRow.includes('District_Name')) {
    return FileType.MCLASS;
  }

  // Check for Linkit file (multiple patterns)
  if (columnsNames) {
    const firstCellValueForLinkIt = "Selected tests";
    if (columnsNames[0] === firstCellValueForLinkIt) {
      return FileType.LINKIT;
    }

    // Check for date-based Linkit pattern
    if (LINKIT_CONSTANTS.indexOf(columnsNames[0]) !== -1) {
      return FileType.LINKIT;
    }
  }

  // Check for Linkit by header columns
  const lowerFirstRow = firstRow.toLowerCase();
  if (LINKIT_CONSTANTS.some(col => lowerFirstRow.includes(col.toLowerCase()))) {
    return FileType.LINKIT;
  }

  // Check for DDMS file - Add specific DDMS detection logic here
  // This is a placeholder - adjust based on actual DDMS file characteristics
  
  return FileType.GENERIC;
}

/**
 * Check if row contains student ID column
 */
export function containsStudentIDColumn(csvRowStr: string): boolean {
  return STUDENT_ID_COLUMNS.some((sid) => csvRowStr.includes(sid));
}

/**
 * Check if array is blank
 */
export function isArrayBlank(csvRowSubStringArray: string[]): boolean {
  return csvRowSubStringArray.every((data) => data.trim() === '');
}

/**
 * Remove blank rows from CSV data
 */
export function removeBlankRows(csvDataArray: string[], studentIDColumns: string[]): string[] {
  const csvRowStrArray: string[] = [];
  let isStringFound: boolean = false;

  for (let i = 0; i < csvDataArray.length; i++) {
    const csvRowStr = csvDataArray[i];
    
    // Skip blank rows until we find the header
    if (!studentIDColumns.some((sid) => csvRowStr.includes(sid)) && !isStringFound) {
      continue;
    }
    
    isStringFound = true;
    const csvRowSubStringArray = csvRowStr.split(',');
    
    if (!isArrayBlank(csvRowSubStringArray)) {
      csvRowStrArray.push(csvRowStr);
    }
  }

  return csvRowStrArray;
}
